import React from 'react';
import processList from 'data/feature/processList';
import Section from 'components/common/Section';
import Process from './Process';
import SectionHeader from './SectionHeader';
import { isIterableArray } from 'helpers/utils';

const Processes = () => (
  <Section>
    <SectionHeader
      title="Бидний шийдэл"
      subtitle="GegeeWeb платформ нь мэдээлэл боловсруулах, хэрэглэгчийн тохиргоо, текст удирдах систем, нууцлал болон хэлний тохиргоог үр дүнтэй удирдахад туслах олон давуу талыг санал болгодог веб сайт удирдах платформ юм."
    />
    {isIterableArray(processList) &&
      processList.map((process, index) => (
        <Process key={process.color} isFirst={index === 0} {...process} />
      ))}
  </Section>
);

export default Processes;
